var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.component,{key:`${_vm.view}_${_vm.since}_${_vm.until}`,tag:"component",attrs:{"accountId":_vm.accountId,"since":_vm.since,"until":_vm.until}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }